import axios from "axios";
import Cookies from "universal-cookie";
import { notifySessionExpired } from "../session";
axios.defaults.baseURL = 'https://api.cobmindex.com/api/v1/';

let refresh = false;
// מונע ניתוק ו-redirect כפולים כששתי בקשות מקבלות 401 במקביל
let expired = false;
const cookie = new Cookies()

axios.interceptors.response.use(
    resp =>
    { 
        refresh = false
        console.log("Good");
        return resp
    } ,
    async error => {
        console.log("Error")
        // כבר בתהליך התנתקות — אין טעם לנסות לרענן שוב
        if (expired) return error;

        if (error.response?.status === 401 && !refresh) {
            refresh = true;
            axios.defaults.headers.common['Authorization'] = null;
            const refershToken = cookie.get('bezkoder-jwt-refresh');

            try {
                const responses = await axios.post('refreshtoken' , {"token":refershToken});

                if (responses.status === 200 && responses.data?.['access_token']) {
                    const accessToken = responses.data['access_token'];
                    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
                    error.config.headers = error.config.headers || {};
                    error.config.headers['Authorization'] = `Bearer ${accessToken}`;
                    refresh = false;
                    return axios(error.config);
                }
                // 2xx בלי טוקן תקין — דינו ככישלון רענון
                throw new Error("Invalid refresh token response");
            }
            catch (refreshError) {
                // הרענון נכשל (השרת מחזיר 403 דרך TokenRefreshException כשהטוקן פג
                // או לא קיים בבסיס הנתונים) — פקיעת סשן = התנתקות מלאה.
                if (expired) return error;
                expired = true;
                notifySessionExpired();
                return error;
            }
        }

        return error;
    });